// 수의사 답변 본문의 굵게(**x**, __x__)와 줄머리 불릿(- , * )을 보기 좋게 표시하기 위한 파서 (DRT-7109).
// 헤딩(#)과 번호 목록(1.)은 그대로 둔다. 마크다운 전체를 지원하지 않는 의도된 최소 구현이다.
// drtail-owner-web src/utils/answer-format.ts 와 같은 동작을 유지한다.

export type AnswerSegment = Readonly<{ text: string; bold: boolean }>
export type AnswerLine = Readonly<{ bullet: boolean; segments: AnswerSegment[] }>

const BULLET = /^\s*[-*•]\s+/
// ***x*** 는 굵게로, 단어 중간의 __(snake__case) 는 그대로 둔다.
const BOLD = /\*{2,3}(.+?)\*{2,3}|(?<!\w)__(.+?)__(?!\w)/g

export const parseAnswerLine = (line: string): AnswerLine => {
  const bullet = BULLET.test(line)
  const body = bullet ? line.replace(BULLET, '') : line
  const segments: AnswerSegment[] = []
  let last = 0
  for (const match of body.matchAll(BOLD)) {
    const index = match.index ?? 0
    if (index > last) {
      segments.push({ text: body.slice(last, index), bold: false })
    }
    segments.push({ text: match[1] ?? match[2] ?? '', bold: true })
    last = index + match[0].length
  }
  if (last < body.length) {
    segments.push({ text: body.slice(last), bold: false })
  }
  // 내용 없는 불릿 줄('- ')은 • 만 덩그러니 남지 않게 불릿으로 보지 않는다
  return { bullet: bullet && segments.length > 0, segments }
}
